module.exports = __webpack_public_path__ + "img/图1-10  过拟合与欠拟合的直观类比.52b797f6.png";